import { track } from "../analytics";
import { CsError } from "../CsError";
import { errorifInvalidPin } from "../pinUtils";

const origin = process.env.REACT_APP_API_ORIGIN ?? ''

export async function pinMutationFunction<TResponse, TRequestBody>(body: TRequestBody, method: 'POST' | 'PUT' | 'DELETE', path: string, pin: string | null) {
  errorifInvalidPin(pin)
  const url = `${origin}/api/${path}`;

  const res = await fetch(url, {
    method,
    headers: {
      Authorization: `Bearer ${pin}`,
      'Content-Type': 'application/json',
    },
    body: body ? JSON.stringify(body) : undefined,
  });

  if (res.ok) {
    try {
      return (await res.json()) as TResponse;
    } catch (e) {
      track('error', 'usePinApiMutation', {}, {
        message: 'Empty success response, returning empty object',
        error: JSON.stringify(e),
      });
      return {} as TResponse;
    }
  } else {
    let errorData: any = null;
    try {
      errorData = await res.json();
    } catch (e) {
      track('error', 'usePinApiMutation', {}, {
        message: 'Failed to parse error response as JSON',
        error: JSON.stringify(e),
      });
      errorData = { userErrorMessage: 'An error occurred' };
    }
    const err: CsError = {...errorData, status: res?.status }
    throw err 
  }
}
